module.exports = __WEBPACK_EXTERNAL_MODULE_77__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vueresize","commonjs2":"vue-resize-directive","commonjs":"vue-resize-directive","amd":"vue-resize-directive"}
// module id = 77
// module chunks = 0